import { isPigmentJsonValue } from "./model.js";
function isPortableRecord(value) {
    if (typeof value !== "object" || value === null || Array.isArray(value))
        return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
/** Strictly recognize the complete portable data-call wire. */
export function isPigmentDataSpec(value) {
    if (!isPortableRecord(value))
        return false;
    if (Object.keys(value).some((key) => key !== "get" && key !== "args"))
        return false;
    if (typeof value.get !== "string" || value.get.length === 0 || value.get !== value.get.trim())
        return false;
    if (value.args === undefined)
        return true;
    return isPortableRecord(value.args) && isPigmentJsonValue(value.args);
}
